module.exports = __webpack_public_path__ + "img/kaiMan.efc4b2c0.png";